import { useState } from "react";
import { format } from "date-fns";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import Buttons from "../components/Buttons";
import AddScreenTitle from "../components/AddScreenTitle";
import GridPage from "../components/GridPage";
import MainLayout from "../components/MainLayout";
import MainPopup from "../popup-containers/MainPopup";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PaymentPopup from "../popup-containers/Paymentpopup";
import { paymentHeader } from "../components/HeaderAttribute";
import { mainTable } from "../css/Common";
import DateRangePicker from "../ReusableComponents/BookingRangePicker";

const Payment = () => {
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [popUpData, setPopUpData] = useState({});

  const [formFields, setFormFields] = useState({
    guestName: "",
    villaType: "",
    checkInDate: "",
    checkOutDate: "",
    paymentDate: "",
    paymentMethod: "",
    advanceAmount: "",
    inventoryAmount: "",
    totalAmount: "",
  });


  const [selection, setSelection] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });

  const [paymentMethods] = useState([
    { value: "cash", label: "Cash" },
    { value: "card", label: "Card" },
    { value: "online", label: "Online Transfer" },
    { value: "cheque", label: "Cheque" },
    { value: "bank", label: "Bank Transfer" },
  ]);

  const [bindPaymentData, setBindPaymentData] = useState([
    {
      guestName: "Alice Fernandez",
      villaType: "Premium Villa",
      checkInDate: "2025-06-10",
      checkOutDate: "2025-06-15",
      paymentDate: "2025-05-20",
      paymentMethod: "UPI",
      advanceAmount: "7000",
      inventoryAmount: "2000",
      totalAmount: "9000",
    },
    {
      guestName: "Rajiv Kumar",
      villaType: "Standard Villa",
      checkInDate: "2025-07-01",
      checkOutDate: "2025-07-04",
      paymentDate: "2025-06-10",
      paymentMethod: "Cash",
      advanceAmount: "3000",
      inventoryAmount: "1000",
      totalAmount: "4000",
    },
    {
      guestName: "Samantha Lee",
      villaType: "Luxury Villa",
      checkInDate: "2025-05-30",
      checkOutDate: "2025-06-03",
      paymentDate: "2025-05-22",
      paymentMethod: "Net Banking",
      advanceAmount: "6000",
      inventoryAmount: "2500",
      totalAmount: "8500",
    },
  ]);

  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedFields = { ...formFields, [name]: value };

    if (name === "advanceAmount" || name === "inventoryAmount") {
      const advance = parseFloat(updatedFields.advanceAmount) || 0;
      const inventory = parseFloat(updatedFields.inventoryAmount) || 0;
      updatedFields.totalAmount = (advance + inventory).toString();
    }

    setFormFields(updatedFields);
  };

  const handleDropdownChange = (name, value) => {
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    let errorsObj = {};
    const requiredFields = [
      "guestName",
      "villaType",
      "checkInDate",
      "checkOutDate",
      "paymentDate",
      "paymentMethod",
      "advanceAmount",
      "inventoryAmount",
      "totalAmount",
    ];

    requiredFields.forEach((field) => {
      if (!formFields[field]) {
        errorsObj[field + "Error"] = "This field is required.";
      } else if (
        ["advanceAmount", "inventoryAmount", "totalAmount"].includes(field)
      ) {
        if (isNaN(formFields[field]) || Number(formFields[field]) < 0) {
          errorsObj[field + "Error"] = "Enter a valid non-negative amount.";
        }
      }
    });

    if (
      formFields.checkInDate &&
      formFields.checkOutDate &&
      new Date(formFields.checkOutDate) < new Date(formFields.checkInDate)
    ) {
      errorsObj.checkOutDateError = "Check-out cannot be before check-in.";
    }

    setErrors(errorsObj);
    return Object.keys(errorsObj).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    const payload = {
      ...formFields,
      checkInDate: format(new Date(formFields.checkInDate), "yyyy-MM-dd"),
      checkOutDate: format(new Date(formFields.checkOutDate), "yyyy-MM-dd"),
      paymentDate: format(new Date(formFields.paymentDate), "yyyy-MM-dd"),
    };

    setBindPaymentData((prev) => [...prev, payload]);
    cancel();
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };

  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setpopUpOpen(false);
    setErrors({});
    setFormFields({
      guestName: "",
      villaType: "",
      checkInDate: "",
      checkOutDate: "",
      paymentDate: "",
      paymentMethod: "",
      advanceAmount: "",
      inventoryAmount: "",
      totalAmount: "",
    });
    setSelection({
      startDate: null,
      endDate: null,
    });
  };

  const handlePayment = (rowIndex, flag) => {
    handleOpen(true);
    setViewDetails(flag === 1);
    setDeleteDetails(flag === 3);
    setBlockDetails(flag === 4);
    setUnBlockDetails(flag === 5);
    setPopUpData(bindPaymentData[rowIndex]);
  };

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  const handleEdit = (rowIndex) => {
    const record = bindPaymentData[rowIndex];
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setFormFields({
      guestName: record.guestName,
      villaType: record.villaType,
      checkInDate: record.checkInDate,
      checkOutDate: record.checkOutDate,
      paymentDate: record.paymentDate,
      paymentMethod: record.paymentMethod,
      advanceAmount: record.advanceAmount,
      inventoryAmount: record.inventoryAmount,
      totalAmount: record.totalAmount,
    });

    setSelection({
      startDate: record.checkInDate,
      endDate: record.checkOutDate,
    });
  };

  return (
    <MainLayout pageName="3">
      {visibleTable && (
        <GridPage
          title="Payment"
          header={paymentHeader}
          records={[...bindPaymentData].sort(
            (a, b) => new Date(b.paymentDate) - new Date(a.paymentDate)
          )}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handlePayment}
          showAdd={showAdd}
        />
      )}

      {visibleAdd && (
        <>
          <div className="flex flex-col w-full">
            <div className={mainTable.clientMasterMainAdd}>
              <AddScreenTitle
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                title="Payment"
              />
            </div>
          </div>

          <div className="flex justify-center">
            <div className="grid gap-2 mb-2 md:grid-cols-2 justify-center w-1/2 items-center">
              <InputText
                title="Guest Name"
                name="guestName"
                content={formFields.guestName}
                controlFunc={handleInputChange}
                errorMessage={errors.guestNameError}
              />
              <InputText
                title="Villa Type"
                name="villaType"
                content={formFields.villaType}
                controlFunc={handleInputChange}
                errorMessage={errors.villaTypeError}
              />
              <InputText
                inputType="date"
                title="Payment Date"
                name="paymentDate"
                content={formFields.paymentDate}
                controlFunc={handleInputChange}
                errorMessage={errors.paymentDateError}
              />

              <DateRangePicker
                title="Check Dates"
                selection={selection}
                onChange={(range) => setSelection(range)}
              />

              <DropDown
                title="Payment Method"
                name="paymentMethod"
                selectedOption={formFields.paymentMethod}
                options={paymentMethods}
                controlFunc={(val) =>
                  handleDropdownChange("paymentMethod", val)
                }
                errorMessage={errors.paymentMethodError}
              />
              <InputText
                title="Advance Amount (₹)"
                name="advanceAmount"
                content={formFields.advanceAmount}
                controlFunc={handleInputChange}
                errorMessage={errors.advanceAmountError}
              />
              <InputText
                title="Inventory Amount (₹)"
                name="inventoryAmount"
                content={formFields.inventoryAmount}
                controlFunc={handleInputChange}
                errorMessage={errors.inventoryAmountError}
              />
              <InputText
                title="Total Amount (₹)"
                name="totalAmount"
                content={formFields.totalAmount}
                controlFunc={handleInputChange}
                errorMessage={errors.totalAmountError}
              />
            </div>
          </div>

          <div className="flex justify-center mt-6">
            <Buttons
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              disabledBtn={false}
              viewSaveButton={false}
              handleSubmit={handleSubmit}
              cancel={cancel}
            />
          </div>
        </>
      )}

      <MainPopup popUpOpen={popUpOpen} setpopUpOpen={setpopUpOpen}>
        <div>
          <PopUpScreenTitle
            title="Payment"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <PaymentPopup data={popUpData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          handleSubmit={handleSubmit}
          cancel={cancel}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default Payment;
